<ng-container *ngIf="(page || paginatedService) else noPage">
    <mat-paginator
            *ngIf="page ? (page?.totalPages > 1) : (paginatedService?.page$ | async)?.totalPages > 1"
            [hidePageSize]="true"
            [length]="page ? page?.totalElements: (paginatedService?.page$ | async)?.totalElements"
            [pageSize]="pagePageSize"
            (page)="onPageChanged($event)"
            [pageIndex]="page ? page.number : (paginatedService?.page$ | async)?.number">
    </mat-paginator>
</ng-container>
<ng-template #noPage>
    <ng-container *ngIf="totalItems && pageSize">
        <div class="d-flex gap-4 justify-content-end" *ngIf="display === 'compact'">
            <app-button iconName="chevron-left" (clickEvent)="pageIndex = pageIndex -1; pageChanged.emit(pageIndex)" *ngIf="pageIndex > 0"></app-button>
            <app-button iconName="chevron-right" (clickEvent)="pageIndex = pageIndex +1; pageChanged.emit(pageIndex)" *ngIf="pageIndex < Math.ceil(totalItems / pageSize) - 1"></app-button>
        </div>
        <mat-paginator *ngIf="display === 'normal'"
                       [hidePageSize]="true"
                       [length]="totalItems"
                       [pageSize]="pageSize"
                       (page)="onPageChanged($event)"
                       [pageIndex]="pageIndex">
        </mat-paginator>
    </ng-container>
</ng-template>
